import { render, staticRenderFns } from "./BlackGoldSlipDetailModal.vue?vue&type=template&id=677dd3e9"
import script from "./BlackGoldSlipDetailModal.vue?vue&type=script&lang=js"
export * from "./BlackGoldSlipDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports